'use strict';

import './dealerChatLink.scss';
import template from './dealerChatLink.template.html';
import controller from './dealerChatLink.controller.js';

const component = {
    bindings: {
        partyId: '@',
        stockTypeCode: '@',
        customerId: '@',
        chatPosition: '@',
        modelYear: '@',
        makeName: '@',
        modelName: '@',
        listingId: '@',
        vin: '@',
        price: '@',
        stockNumber: '@',
        pageFromId: '@',
        hasChatEnabled: '@',
        isCpoVehicle: '@',
        isDealerInspire: '@',
        linkLocation: '@',
        isInLeadFormModal: '<',
        dealerInspireSmsNumber: '@',
        showVdpLeadForm: '<'
    },
    controller,
    template
};

export default component;
